"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyDetailsInputDtoLandAreaUnitEnum = exports.PropertyDetailsInputDtoPropertyCategoryEnum = void 0;
exports.instanceOfPropertyDetailsInputDto = instanceOfPropertyDetailsInputDto;
exports.PropertyDetailsInputDtoFromJSON = PropertyDetailsInputDtoFromJSON;
exports.PropertyDetailsInputDtoFromJSONTyped = PropertyDetailsInputDtoFromJSONTyped;
exports.PropertyDetailsInputDtoToJSON = PropertyDetailsInputDtoToJSON;
exports.PropertyDetailsInputDtoToJSONTyped = PropertyDetailsInputDtoToJSONTyped;
var PropertyAddressValuationEnquiryInput_1 = require("./PropertyAddressValuationEnquiryInput");
var PropertyTypeInput_1 = require("./PropertyTypeInput");
/**
 * @export
 */
exports.PropertyDetailsInputDtoPropertyCategoryEnum = {
    Residential: 'residential',
    Rural: 'rural',
    Land: 'land'
};
/**
 * @export
 */
exports.PropertyDetailsInputDtoLandAreaUnitEnum = {
    Sqm: 'sqm',
    Acre: 'acre',
    Hectare: 'hectare'
};
/**
 * Check if a given object implements the PropertyDetailsInputDto interface.
 */
function instanceOfPropertyDetailsInputDto(value) {
    if (!('propertyCategory' in value) || value['propertyCategory'] === undefined)
        return false;
    if (!('propertyType' in value) || value['propertyType'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    return true;
}
function PropertyDetailsInputDtoFromJSON(json) {
    return PropertyDetailsInputDtoFromJSONTyped(json, false);
}
function PropertyDetailsInputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'propertyCategory': json['propertyCategory'],
        'propertyType': (0, PropertyTypeInput_1.PropertyTypeInputFromJSON)(json['propertyType']),
        'title': json['title'] == null ? undefined : json['title'],
        'address': (0, PropertyAddressValuationEnquiryInput_1.PropertyAddressValuationEnquiryInputFromJSON)(json['address']),
        'landAreaUnit': json['landAreaUnit'] == null ? undefined : json['landAreaUnit'],
        'landArea': json['landArea'] == null ? undefined : json['landArea'],
        'bedrooms': json['bedrooms'] == null ? undefined : json['bedrooms'],
        'bathrooms': json['bathrooms'] == null ? undefined : json['bathrooms'],
        'carPorts': json['carPorts'] == null ? undefined : json['carPorts'],
        'photoUrls': json['photoUrls'] == null ? undefined : json['photoUrls'],
        'floorPlanUrls': json['floorPlanUrls'] == null ? undefined : json['floorPlanUrls'],
    };
}
function PropertyDetailsInputDtoToJSON(json) {
    return PropertyDetailsInputDtoToJSONTyped(json, false);
}
function PropertyDetailsInputDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'propertyCategory': value['propertyCategory'],
        'propertyType': (0, PropertyTypeInput_1.PropertyTypeInputToJSON)(value['propertyType']),
        'title': value['title'],
        'address': (0, PropertyAddressValuationEnquiryInput_1.PropertyAddressValuationEnquiryInputToJSON)(value['address']),
        'landAreaUnit': value['landAreaUnit'],
        'landArea': value['landArea'],
        'bedrooms': value['bedrooms'],
        'bathrooms': value['bathrooms'],
        'carPorts': value['carPorts'],
        'photoUrls': value['photoUrls'],
        'floorPlanUrls': value['floorPlanUrls'],
    };
}
